import React, { useState } from 'react';
import PropTypes from 'prop-types';
import OrderDndItem from './order-push-dnd-item';
import OrderDndPreview from './order-push-dnd-preview';
import OrderPushDndGraphic from './order-push-dnd-graphic';
import './order-push-dnd-items.scss';

const OrderPushDndItems = ({
	handleSetPreview, 
	isCompleted,
	previewList,
	currentPreview,
	itemList,
	languageId,
	taskData,
	handleSwitchItems,
	handleUnsetPreview
}) => {
	const [currentDraggedItemId, setCurrentDraggedItemId] = useState(null);

	return (
		<div id="orderItems" className="OrderPushDndItems-items">
			{itemList.map((item, index) => {
				const itemData = taskData.items.find((i) => {return i.id === item.id;});
				if (!itemData) return null;
				let isDraggable = true;
				let classes = null;
				const isPlacedCorrect = itemData.correctOrderNumbers.indexOf(index + 1) >= 0;
				if (isCompleted || (item.isLocked && isPlacedCorrect)) {
					isDraggable = false;
					classes = ['correct'];
				}

				let previewItemData = null;
				if (previewList) {
					previewItemData = previewList.find((preview) => {
						return preview.item.id === item.id;
					});
				}

				let itemLocation = item.location;
				if (previewItemData) {
					itemLocation = previewItemData.location;
				}

				const isLast = index === itemList.length - 1;

				return (
					<div key={item.id} className={'OrderPushDndItems-item' + (isLast ? ' isLast' : '')}>
						<div className='OrderPushDndItems-itemNumber'>
							<span>{index + 1}.</span>
						</div>
						<div className={'OrderPushDndItems-itemContainer' +
							(previewItemData ? ' location-' + previewItemData.location : ' location-' + item.location)}>
							<OrderDndItem
								isDraggable={isDraggable} 
								itemIndex={index}
								itemData={itemData}
								itemLocation={itemLocation}
								currentPreview={currentPreview}
								previewItemData={previewItemData}
								previewList={previewList}
								handleSetPreview={handleSetPreview}
								handleSwitchItems={handleSwitchItems}
								handleUnsetPreview={handleUnsetPreview}
								setCurrentDraggedItemId={setCurrentDraggedItemId}
							/>
						</div>
						<div className={'OrderPushDndItems-graphicContainer' + 
							(previewItemData ? ' location-' + previewItemData.location : ' location-' + item.location)}>
							<OrderPushDndGraphic 
								itemData={itemData}
								classes={classes}
								isDragging={currentDraggedItemId === itemData.id}
								languageId={languageId}
								audioFileName={languageId + '-' + taskData.taskId + '-' + itemData.id}
							/>
						</div>
					</div>
				);
			})}
			<OrderDndPreview orderedItems={itemList} itemsData={taskData.items} languageId={languageId} />
		</div>
	);
};

OrderPushDndItems.propTypes = {
	isCompleted: PropTypes.bool.isRequired,
	previewList: PropTypes.array,
	currentPreview: PropTypes.object,
	itemList: PropTypes.array.isRequired,
	languageId: PropTypes.string.isRequired,
	taskData: PropTypes.object.isRequired,
	handleSwitchItems: PropTypes.func.isRequired,
	handleSetPreview: PropTypes.func.isRequired,
	handleUnsetPreview: PropTypes.func.isRequired,
};

export default OrderPushDndItems;